import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Book from "./Book";
import Filter from "./Filter";
import fetchBook from "../redux/books/thunk/fetchBook";
function Booklist({query}){
    const books = useSelector(state=> state.books);
    const filter = useSelector(state=> state.filters);  
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchBook);
    }, [dispatch]);


    const filterByStatus = (books) => { 
        switch (filter.filter) {
            case "feature":
                return books.featured;            
            default:
                return true;
        }
    };    
    const filterByQuery = (books) => { 
        return books.name.toUpperCase().includes(query.toUpperCase());
    }; 
    return(
        <div className="order-2 xl:-order-1">
            <Filter />
            <div className="lws-bookContainer">                
                {books.filter(filterByQuery).filter(filterByStatus).map(books=> <Book books={books} key={books.id} />)}
            </div>
        </div>
    );

}

export default Booklist;